import { createStore } from "vuex";
//localStrong获取写入方法
import { getItem, setItem } from "@/utils/storage";
import { ElMessage } from "element-plus";
import router from "@/router";
//axios
import $http from "@/utils/request";
const TOKEN_KEY = "MOREQUICK";
const PAGES_KEY = "pages";
export default createStore({
  state: {
    //配置图片/接口ip前缀
    ip: localStorage["host"] || "/",
    //用户数据
    userInfo: getItem(TOKEN_KEY) || {},
    screenWidth: null,
    //系统权限代码
    SysGrant: {
      SetPersonalInfo: 21, //修改个人资料
      ShowBrand: 22, //查看品牌列表
      RefundOrder: 23, //订单退款
      DelOrder: 24, //删除订单
      SetSubHotels: 51, //管理子账号门店
      SetPmsSettings: 52, //管理PMS配置
      AddAccount: 102, //添加账号
      AddHotel: 103, //添加门店
      AddWashDevice: 106, //添加洗衣机设备
      DelAccount: 202, //删除账号
      DelHotel: 203, //删除门店
      DelWashDevice: 206, //删除洗衣机设备
      GetAllGroup: 301, //查看所有用户组
      GetAllAccount: 302, //查看所有账号信息
      GetAllHotel: 303, //查看所有门店信息
      GetAllBrand: 305, //查看所有品牌
      GetAllWashDevice: 306, //查看所有洗衣机设备
      GetAllWashSettings: 307, //查看所有洗衣机对接配置
      GetAllResource: 391, //查看所有资源
      GetAllServerConfig: 392, //查看所有服务端配置
      GetAllAccountLogin: 393, //查看所有账号登录日志
      GetAllAccountLog: 394, //查看所有账号操作日志
      GetAllMessage: 396, //查看所有消息通知
      SetAllGroup: 401, //管理所有用户组
      SetAllAccount: 402, //管理所有账号信息
      SetAllHotel: 403, //管理所有门店信息
      SetAllBrand: 405, //管理所有品牌
      SetAllWashDevice: 406, //管理所有洗衣机设备
      SetAllWashSettings: 407, //管理所有洗衣机对接配置
      SetAllResource: 491, //管理所有资源
      SetAllServerConfig: 492, //管理所有服务端配置
      SetAllMessage: 496, //管理所有消息通知
    },
    //存活心跳计时器
    aliveTimer: null,
    //token存活时间
    tokenTime: getItem("tokenTime") || 0,
    //记住登录
    remember: getItem("remember") || false,
  },
  getters: {
    //验证token是否过期
    checkToken(state) {
      return state.tokenTime
        ? Date.now() - state.tokenTime < 5 * 60 * 1000
        : true;
    },
    //获取token
    getToken(state) {
      return state.userInfo.token;
    },
    //获取loginkey
    getLoginkey(state) {
      return state.userInfo.loginkey;
    },
  },
  mutations: {
    //写入用户信息
    setUser(state, data) {
      state.userInfo = { ...state.userInfo, ...data };
      //为了防止刷新丢失，我们需要把数据备份到本地缓存
      setItem(TOKEN_KEY, state.userInfo);
    },
    //清空用户信息
    clearUser(state, data) {
      state.userInfo = {};
      //为了防止刷新丢失，我们需要把数据备份到本地缓存
      setItem(TOKEN_KEY, state.userInfo);
    },
    //写入屏幕宽度
    setWidth(state, data) {
      state.screenWidth = data;
    },
    //写入存活的时间
    setTokenTime(state, time) {
      state.tokenTime = time;
      //为了防止刷新丢失，我们需要把数据备份到本地缓存
      setItem("tokenTime", state.tokenTime);
    },
    //写入存活计时器
    setAliveTimer(state, timer) {
      state.aliveTimer = timer;
    },
    //清空存活计时器
    clearAliveTimer(state) {
      if (state.aliveTimer) clearTimeout(state.aliveTimer);
      state.aliveTimer = null;
    },
    //写入记住登录
    setRemember(state, data) {
      state.remember = data;
      //为了防止刷新丢失，我们需要把数据备份到本地缓存
      setItem("remember", state.remember);
    },
  },
  actions: {
    // 存活请求
    aliveGet({ getters, commit, dispatch }) {
      commit("clearAliveTimer");
      return new Promise((resolve, reject) => {
        if (getters.getToken) {
          $http
            .get("webapi/alive", {
              params: {
                token: getters.getToken,
              },
            })
            .then(({ data: res }) => {
              if (res.code == 0) {
                commit("setTokenTime", res.data.time);
                commit(
                  "setAliveTimer",
                  setTimeout(() => {
                    dispatch("aliveGet");
                  }, 1000 * 60 * 4)
                );
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((err) => {
              resolve(false);
            });
        } else {
          resolve(false);
        }
      });
    },
    // 自动登录
    loginAuto({ getters, commit }) {
      return new Promise((resolve, reject) => {
        if (getters.getLoginkey) {
          $http
            .post("webapi/login", {
              loginkey: getters.getLoginkey,
            })
            .then(({ data: res }) => {
              if (res.code == 0 && res.data.pages) {
                commit("setTokenTime", Date.now());
                commit("setUser", res.data);
                ElMessage({
                  message: "登录成功",
                  type: "success",
                });
                // 带有路径的对象
                router.push({ path: "/home" });
                resolve(true);
              } else {
                if (!res.data.pages) {
                  ElMessage({
                    message: "该账号没有任何权限，请联系管理员添加权限",
                    type: "success",
                  });
                }
                commit("setUser", { loginkey: "" });
                router.replace({ path: "/login" });
                resolve(false);
              }
            })
            .catch((err) => {
              resolve(false);
            });
        } else {
          resolve(false);
        }
      });
    },
  },
  modules: {},
});
